import styles from './styles.module.scss';

import { useEffect, useRef } from 'react';

interface ReportProps extends React.HTMLAttributes<HTMLDivElement> {
    report: string;
}

export const Report = ({ report }: ReportProps) => {
    const iframeRef = useRef<HTMLIFrameElement>(null);

    useEffect(() => {
        const iframeElement = iframeRef.current;

        if (iframeElement) {
            iframeElement.contentDocument!.open();
            iframeElement.contentDocument!.write(report);
            iframeElement.contentDocument!.close();
        }
    }, []);

    return (
        <iframe
            id='report'
            className={styles.reportIframe}
            ref={iframeRef}
            title='Embedded HTML Content'
            width='100%'
            height='100%'
        />
    );
};
